<template>
  <generic-column-name-edition
    :value="generic_column_name"
    v-bind="$props"
    v-on="listeners_for_generic_column_name_edition"
    @input="validate_edition($event)"
  >
    <template #right_element="{in_edition}">
      <b-form-select v-if="in_edition" v-model="type" :options="type_options" />
      <span v-else>
        {{ type }}
      </span>
    </template>
    <template #bottom_element="{in_edition}">
      <div v-if="in_edition">
        <coercion-date-formats v-if="type == 'date'" v-model="date_formats" />
      </div>
      <div v-else>
        <b-badge
          v-for="format in date_formats"
          :key="format"
          pill
          variant="primary"
          class="px-1 mr-1"
        >
          {{ format }}
        </b-badge>
      </div>
    </template>
  </generic-column-name-edition>
</template>

<script>
import _ from 'lodash'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import CoercionDateFormats from './coercion_date_formats.vue'
import { GenericColumnNameForCoercion } from '@/components/object_model.js'

export default {
  name: 'GenericColumnNameEditionForCoercion',
  components: {
    GenericColumnNameEdition,
    CoercionDateFormats,
  },
  props: [...GenericColumnNameEdition.props, 'only_manual'],
  data() {
    return {
      generic_column_name: undefined,
      type: '',
      date_formats: [],
      type_options: [
        { value: '', text: this.$t('choose_a_type') },
        { value: 'string', text: this.$t('string') },
        { value: 'number', text: this.$t('number') },
        { value: 'date', text: 'Date' },
      ],
    }
  },

  computed: {
    listeners_for_generic_column_name_edition() {
      return _.omit(this.$listeners, 'input')
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.generic_column_name = _.cloneDeep(nv.generic_column_name)
          this.type = nv.type
          this.date_formats = _.cloneDeep(nv.date_formats)
        }
      },
    },
  },

  methods: {
    validate_edition(generic_column_name) {
      let new_value = new GenericColumnNameForCoercion(
        generic_column_name.name,
        generic_column_name.contains_metavariables,
        this.type,
        this.date_formats
      )
      this.$emit('input', new_value)
    },
  },
}
</script>
